// `favicon.href` já vem absoluto e com a query de cache-busting (`?v=...`)
// que a tag <link> do layout carrega. Construir o nome do arquivo do zero
// (como antes) perdia essa query, e o navegador podia continuar servindo do
// cache uma versão de favicon-badge anterior a uma troca de marca — o ícone
// normal atualizava (link tem `?v=`), o de notificação não. Por isso troca-se
// só o nome do arquivo dentro do href já existente, preservando a query.
const withBadgeSuffix = (href, wantBadge) => {
  const base = href.replace('/favicon-badge-', '/favicon-');
  return wantBadge ? base.replace('/favicon-', '/favicon-badge-') : base;
};

// O badge so existe para chamar atencao de quem nao esta olhando. Quem decide
// pintar (`onNewMessage`, e o reforco de 30 em 30s) usa o
// WindowVisibilityHelper, que considera "invisivel" tambem a aba visivel mas
// sem foco — entao o badge era pintado com a aba na frente do usuario. Como a
// unica limpeza era o `visibilitychange`, que nunca dispara numa aba que jamais
// foi escondida, o badge ficava preso ate o F5. Esta e a mesma regra nos dois
// lados: pinta so quando ninguem esta olhando, limpa assim que alguem olha.
const usuarioEstaOlhando = () =>
  document.visibilityState === 'visible' && document.hasFocus();

export const showBadgeOnFavicon = () => {
  if (usuarioEstaOlhando()) return;

  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    favicon.href = withBadgeSuffix(favicon.href, true);
  });
};

// O `set` do DashboardAudioNotificationHelper chama esta funcao a cada
// reinicializacao dos alertas, e o heartbeat de sessao do App.vue faz isso a
// cada 5 segundos. Sem esta guarda, cada chamada somava mais um listener de
// `visibilitychange` que nunca era removido — cerca de 720 por hora de aba
// aberta, todos disparando de uma vez quando a pessoa volta para a aba, cada
// um reescrevendo o `href` dos tres <link> de favicon. Um listener ja faz o
// trabalho inteiro; os demais eram repeticao pura.
let switcherRegistrado = false;

export const initFaviconSwitcher = () => {
  if (switcherRegistrado) return;
  switcherRegistrado = true;

  const favicons = document.querySelectorAll('.favicon');

  const limparBadge = () => {
    if (document.visibilityState !== 'visible') return;

    favicons.forEach(favicon => {
      favicon.href = withBadgeSuffix(favicon.href, false);
    });
  };

  document.addEventListener('visibilitychange', limparBadge);
  // `visibilitychange` nao dispara quando a aba continuou visivel e so voltou a
  // ter foco (usuario estava noutra janela). Sem o `focus`, o badge pintado
  // durante o blur so sairia no proximo F5.
  window.addEventListener('focus', limparBadge);
};
